import { LegalLayout } from "@/components/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-white mt-4">
    {children}
  </h2>
);

const P = ({ children }) => (
  <p className="text-base text-slate-400 leading-relaxed">{children}</p>
);

const UL = ({ items }) => (
  <ul className="flex flex-col gap-2 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-3 text-base text-slate-400 leading-relaxed">
        <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#00DC82]" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const Section = ({ children }) => (
  <section className="flex flex-col gap-4">{children}</section>
);

export default function Safety() {
  return (
    <LegalLayout title="SAFETY NOTICE">
      <Section>
        <P>Last Updated: July 2026</P>
        <P>Driving comes first.</P>
        <P>
          MockTP is designed to assist driving instructors during mock driving assessments.
          It is not intended to distract from the safe operation of a vehicle.
        </P>
      </Section>

      <Section>
        <H2>Important Safety Information</H2>
        <UL
          items={[
            "The instructor is always responsible for the safe control and supervision of the lesson.",
            "Never interact with MockTP if doing so could compromise safety.",
            "Only record assessment items when it is safe to do so.",
            "If necessary, stop the vehicle in a safe location before using the app.",
            "Always comply with local road traffic laws and regulations.",
          ]}
        />
      </Section>

      <Section>
        <H2>Professional Judgement</H2>
        <P>MockTP is an assessment and record-keeping tool.</P>
        <P>
          The app does not replace professional judgement, instructor experience or
          official driving test standards.
        </P>
        <P>The instructor remains fully responsible for:</P>
        <UL
          items={[
            "Conducting lessons safely.",
            "Supervising the student.",
            "Assessing driving performance.",
            "Deciding when intervention is necessary.",
          ]}
        />
      </Section>

      <Section>
        <H2>No Emergency Use</H2>
        <P>MockTP must never be used during an emergency situation.</P>
        <P>
          If immediate attention is required, stop using the app and focus entirely on
          driving safety.
        </P>
      </Section>

      <Section>
        <H2>Device Use</H2>
        <P>Always ensure your mobile device is securely mounted where permitted by law.</P>
        <P>
          Never hold or operate a mobile device while driving if prohibited by local
          regulations.
        </P>
      </Section>

      <Section>
        <H2>Responsibility</H2>
        <P>
          By using MockTP you acknowledge that safe driving instruction always takes
          priority over using the application.
        </P>
      </Section>

      <Section>
        <H2>Final Statement</H2>
        <P>Our goal is to reduce paperwork—not attention to the road.</P>
        <P>Teach safely.</P>
        <P>Drive safely.</P>
      </Section>
    </LegalLayout>
  );
}
